import React, { useRef } from 'react'
import './card.css'
import TransitionLink from '../../transitions/TransitionLink'
import { gsap } from 'gsap'

export default function Card({ id, name, img, tags, description }) {
  const cardRef = useRef(null)
  const quickRotX = useRef(null)
  const quickRotY = useRef(null)

  const getExcerpt = (text) => {
    if (!text) return '';
    if (text.length <= 300) return text;
    return text.slice(0, 300).trim() + '...';
  };
  const ensureQuickSetters = () => {
    if (quickRotX.current) return
    quickRotX.current = gsap.quickTo(cardRef.current, 'rotateX', { duration: 0.5, ease: 'power3.out' })
    quickRotY.current = gsap.quickTo(cardRef.current, 'rotateY', { duration: 0.5, ease: 'power3.out' })
  }

  const handleMouseEnter = () => {
    ensureQuickSetters()
    gsap.to(cardRef.current, { y: -8, scale: 1.015, duration: 0.4, ease: 'power3.out' })
  }

  const handleMouseMove = (e) => {
    ensureQuickSetters()
    const rect = cardRef.current.getBoundingClientRect()
    const px = (e.clientX - rect.left) / rect.width  
    const py = (e.clientY - rect.top) / rect.height   

    const maxTilt = 8 
    quickRotX.current(-(py - 0.5) * maxTilt * 2)
    quickRotY.current((px - 0.5) * maxTilt * 2)
    cardRef.current.style.setProperty('--glare-x', `${px * 100}%`)
    cardRef.current.style.setProperty('--glare-y', `${py * 100}%`)
  }

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, { rotateX: 0, rotateY: 0, y: 0, scale: 1, duration: 0.6, ease: 'power3.out' })
  }

  return (
    <TransitionLink
      to={`/project/${id}`}
      className="card"
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="card-media">
        <div className="card-chrome">
          <span className="dot dot-red"></span>
          <span className="dot dot-yellow"></span>
          <span className="dot dot-green"></span>
        </div>
        <img src={img} alt={`Aperçu du projet ${name}`} className="card-image" />
        <div className="card-glare" aria-hidden="true"></div>
      </div>
      <div className="card-body">
        <div className="container-tag">
          {tags?.map((tag, i) => (
            <span className="tag" key={i}>{tag.tag}</span>
          ))}
        </div>
        <h2 className="card-title">{name}</h2>
        <p className="description">{getExcerpt(description)}</p>
        <span className="card-link">Voir le projet <span>→</span></span>
      </div>
    </TransitionLink>
  )
}
